<template>
  <standart-template>
    <div class="mb-4 text-grey">
      <div class="text-xl font-semibold">Документы</div>
      <div class="mt-1 text-sm text-grey text-opacity-50">
        Подпишите и отправьте документы в один клик
      </div>
    </div>

    <document-item
      v-for="document in documents"
      :key="document.id"
      :document="document"
      @sign="onSign"
      @open="onOpen"
      @download="onDownload"
      @send="onSend"
    />

    <pdf-preview-modal
      :state="previewModalState"
      :url="previewDocumentUrl"
      :file-name="previewDocumentName"
      @close="previewModalState = false"
    />

    <signature-pad-modal
      :state="signModalState"
      :document="signDocument"
      @signed="onSigned"
      @close="signModalState = false"
    />

    <StatusModal
      type="success"
      description="Документ отправлен"
      button-text="Хорошо"
      :state="sendStatusState"
      @confirm="sendStatusState = false"
    />
  </standart-template>
</template>

<script lang="ts">
import DocumentItem from "@/components/Documents/DocumentItem.vue";
import PdfPreviewModal from "@/components/Documents/PdfPreviewModal.vue";
import SignaturePadModal from "@/components/Documents/SignaturePadModal.vue";
import StatusModal from "@/components/Modals/StatusModal.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import { IDocument } from "@/struct/IDocument/IDocument";
import { Getter, Mutation } from "s-vuex-class";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    StandartTemplate,
    DocumentItem,
    PdfPreviewModal,
    SignaturePadModal,
    StatusModal,
  },
})
export default class DocumentsPage extends Vue {
  @Getter("getDocuments") private documents!: IDocument[];
  @Mutation("setDocumentSigned")
  private setDocumentSigned: ((payload: { id: string; url: string }) => void) | undefined;
  @Mutation("setDocumentNotNew") private setDocumentNotNew: ((id: string) => void) | undefined;

  private previewModalState = false;
  private previewDocumentUrl = "";
  private previewDocumentName = "";

  private signModalState = false;
  private signDocument: IDocument | null = null;

  private sendStatusState = false;

  private onSign(document: IDocument) {
    this.signDocument = document;
    this.signModalState = true;
  }

  private onSend(document: IDocument) {
    this.setDocumentNotNew?.(document.id);
    this.sendStatusState = true;
  }

  private onSigned(objectUrl: string) {
    if (this.signDocument) {
      this.setDocumentSigned?.({
        id: this.signDocument.id,
        url: objectUrl,
      });
    }
    this.signModalState = false;
  }

  private onOpen(document: IDocument) {
    this.previewDocumentUrl = document.url;
    this.previewDocumentName = document.name;
    this.previewModalState = true;
  }

  private async onDownload(item: IDocument) {
    const response = await fetch(item.url);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = item.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);
  }
}
</script>
